import { Button } from "@mui/material";
import logo247UpTime from "../assets/247uptime-logo.svg";
import { useNavigate } from "react-router";
function OrderSubscriptionHeader() {

  const navigate = useNavigate();

  const handleLogin = () => {
    localStorage.clear();
    navigate("/login");
  }


  return (
    <div className="subscription-header">
      <div className="__header">
        <div>
          <img
            src={logo247UpTime}
            style={{
              width: "auto",
              height: "48px",
              margin: "28px 100px",
              cursor: "pointer",
            }}
            alt="247UpTime Logo"
            onClick={() => {
              window.location.href = "/login";
            }}
          />
        </div>
        <div className="__title">Industrie 4.0 Lösungen, die überzeugen.</div>
      </div>

      <div className="__login">
        <Button variant="outlined" color="primary" onClick={handleLogin}> Login </Button>
      </div>
    </div>
  );
}
export default OrderSubscriptionHeader;
